import { initializeTheme } from '@/lib/theme/theme-store'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { AppProviders } from '@/app/AppProviders'
import { router } from '@/app/router'
import { initializeObservability } from '@/lib/observability'
import { loadRuntimeConfig } from '@/lib/runtime-config'
import './index.css'

initializeTheme()

async function bootstrap() {
  const config = await loadRuntimeConfig()
  initializeObservability(config)

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
    </StrictMode>,
  )
}

void bootstrap()
